import { render, staticRenderFns } from "./MigracaoProcessoTableComponent.vue?vue&type=template&id=e643912c&scoped=true&lang=pug"
import script from "./MigracaoProcessoTableComponent.vue?vue&type=script&lang=js"
export * from "./MigracaoProcessoTableComponent.vue?vue&type=script&lang=js"
import style0 from "./MigracaoProcessoTableComponent.vue?vue&type=style&index=0&id=e643912c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e643912c",
  null
  
)

export default component.exports